module.exports = __webpack_public_path__ + "assets/img/54af-nr.svg";